import React from "react";

const LanguageContext = React.createContext({
  language: "en",
  toggleLanguage: (language: string) => {}
});

export default LanguageContext;
